import { formatDateUTCToTimeLocal } from "@utils/datetime";
import { 
  Flex, 
  Icons,
} from "@components/index";

interface TimesFragmentType {
  plannedExecutionStart?: string;
  plannedExecutionEnd?: string;
  executionStart?: string;
  executionEnd?: string;
  gapCol: string;
  gapRow: string;
}

const TimesFragment: React.FC<React.HTMLAttributes<HTMLDivElement> & TimesFragmentType> = ({ 
  plannedExecutionStart,
  plannedExecutionEnd,
  executionStart,
  executionEnd,
  gapCol,
  gapRow,
}) => (
  <Flex.Col gap={gapCol}>
    <Flex.Row gap={gapRow} alignItems="center">
      <Icons icon="calendar" size="md" />
      <span className="center min-w-50">{formatDateUTCToTimeLocal(plannedExecutionStart, "--:--")}</span>
      |
      <span className="center min-w-50">{formatDateUTCToTimeLocal(plannedExecutionEnd, "--:--")}</span>
    </Flex.Row>

    <Flex.Row gap={gapRow} alignItems="center">
      <Icons icon="time" size="md" />
      <span className="center min-w-50">{formatDateUTCToTimeLocal(executionStart, "--:--")}</span>
      |
      <span className="center min-w-50">{formatDateUTCToTimeLocal(executionEnd, "--:--")}</span>
    </Flex.Row>
  </Flex.Col>
);

export default TimesFragment;